<template>
  <div class="card shadow">
    <img
      :src="`/img/people/${person.slug}@2x.png`"
      :alt="person.firstName + ' ' + person.lastName"
      width="80"
      height="80"
      class="card-image rounded-full"
    />
    <div class="pl-3">
      <router-link
        :to="{ name: 'people-person', params: { person: person.slug } }"
        class="text-xl leading-tight"
      >
        {{ person.firstName }} {{ person.lastName }}
      </router-link>
      <p class="text-sm leading-tight font-bold text-vividred-800">{{ person.title }}</p>
      <p class="text-xs align-middle mt-2" v-if="person.linkedIn">
        <PhLinkedinLogo :size="16" class="inline-block align-middle" />
        <a
          :href="person.linkedIn"
          target="_blank"
          :title="`Connect with ${person.firstName} on LinkedIn.`"
          class="align-middle"
          >LinkedIn</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { PhLinkedinLogo } from 'phosphor-vue';
export default {
  props: ['person'],
  components: { PhLinkedinLogo }
};
</script>

<style lang="scss"></style>
